import { render, staticRenderFns } from "./DetectionLabelChip.vue?vue&type=template&id=5791c45b&scoped=true"
import script from "./DetectionLabelChip.vue?vue&type=script&lang=ts"
export * from "./DetectionLabelChip.vue?vue&type=script&lang=ts"
import style0 from "./DetectionLabelChip.vue?vue&type=style&index=0&id=5791c45b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5791c45b",
  null
  
)

export default component.exports